import { render, staticRenderFns } from "./IndexSwiper.vue?vue&type=template&id=6d6152c7&scoped=true&"
import script from "./IndexSwiper.vue?vue&type=script&lang=js&"
export * from "./IndexSwiper.vue?vue&type=script&lang=js&"
import style0 from "./IndexSwiper.vue?vue&type=style&index=0&id=6d6152c7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6152c7",
  null
  
)

export default component.exports